<template>
  <div>
    <el-form-item
      ref="formItem"
      :label-width="$attrs['label-width']"
      :prop="$attrs['prop']"
      :label="$attrs['label']"
      :style="$attrs['style']"
    >
      <el-row :gutter="0">
        <el-col class="col_positon">
          <el-input v-model="id" class="left_input"></el-input>
          <div class="more_box flex_center flex_center_align">
            <img class="icon" src="~@/assets/images/input_edit.png" alt="" />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
  export default {
    name: 'VabMode',
    props: {
      gutter: {
        type: Number,
        default: 10,
      },
      labelWidth: {
        type: String,
        default: null,
      },
      span1: {
        type: Number,
        default: 5,
      },
      span2: {
        type: Number,
        default: 4,
      },
      span3: {
        type: Number,
        default: 12,
      },
      span4: {
        type: Number,
        default: 2,
      },
      //建物ＣＤ
      blgscd: {
        type: [String, Array],
        default: null,
      },
      //棟ＣＤ
      bldgcd: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        id: '',
      }
    },
    computed: {},
    methods: {},
  }
</script>

<style scoped>
  .left_input /deep/ .el-input__inner {
    position: relative;
    padding-right: 35px;
  }
  .left_input /deep/ .el-input__inner:hover {
    border-color: #cecece !important;
  }
  .left_input /deep/ .el-input__inner:active {
    border-color: #cecece !important;
  }
  .left_input /deep/ .el-input-group__append {
    background: none !important;
    border: 1px solid #cecece !important;
    border-left: none !important;
  }
</style>
<style scoped lang="scss">
  .col_positon {
    position: relative;
  }
  .left_input {
    ::v-deep {
      .el-input__inner {
        position: relative;
        padding-right: 35px;
        &:after {
          content: '';
          background: red;
          position: absolute;
          right: 0;
          top: 0;
          width: 35px;
          height: 35px;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .more_box {
    width: 32px;
    height: 32px;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 3px;
    .icon {
      width: 14px;
      height: auto;
    }
  }
</style>
